import Moment from 'moment';
export interface IFindTransactionModel {
    transaction_type: number[];
    payment_request_type?: number;
    payment_id?: string;
    order_id?: string;
    ref_id?: string;
    customer_phone?: string;
    customer_email?: string;
    card_first_eight?: string;
    card_last_four?: string;
    from_date: string;
    to_date: string;
    include_fail: boolean;
    page_size: number;
    page: number;
}

export class FindTransactionModel implements IFindTransactionModel {
    constructor(
        transaction_type: number[] = [1],
        from_date: string = Moment().startOf('day').toJSON(),
        to_date: string = Moment().endOf('day').toJSON(),
        include_fail: boolean = false,
        page_size: number = 25,
        page: number = 1
    ) {
        this.transaction_type = transaction_type;
        this.from_date = from_date;
        this.to_date = to_date;
        this.include_fail = include_fail;
        this.page_size = page_size;
        this.page = page;
    }
    transaction_type: number[];
    payment_request_type?: number | undefined;
    payment_id?: string | undefined;
    order_id?: string | undefined;
    ref_id?: string | undefined;
    customer_phone?: string | undefined;
    customer_email?: string | undefined;
    card_first_eight?: string | undefined;
    card_last_four?: string | undefined;
    from_date: string;
    to_date: string;
    include_fail: boolean;
    page_size: number;
    page: number;
}